<template>
	<div class="col-12 pl-0 pr-0">
		<GChart
		type="PieChart"
		:data="chartData"
		:options="chartOptions"
		:resizeDebounce="500"
		/>
		<div class="col-8 total">
			<!-- <div class="col-12 font-weight-bold">990.000.000</div>
			<div class="col-12 font-size-9">Total Pendapatan</div> -->
		</div>
	</div>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
	components: {
		GChart
	},
	name: 'IChart',
	data() {
		return {
			// chartData: [
			// ['Status', 'Qty'],
			// ['Penjualan langsung', 111],
			// ['Mitra Baru', 12],
			// ],
			chartOptions: {
				legend: {
					position: 'bottom',
				},
				tooltip: {
					ignoreBounds: false,
					text: 'value',
				},
				chartArea:{
					left:5,
					top:30,
					width:'100%'
					,height:'75%'
				},
				pieHole: 0.8,
				fontName: 'Poppins',
				fontSize: 12,
				width: '100%',
				height: 300,
				pieSliceText: 'none',
				colors: ['#563A9C', '#8B5DFF', '#FFCF81', '#FDFFAB', '#87A2FF', '#C4D7FF', '#50B498', '#9CDBA6', '#C13131', '#FF5B44']
			},
		}
	},
	props:{
		chartData:{
			type:Array
		}
	}
};
</script>

<style>
.total {
	position: absolute;
	z-index: 2;
	text-align: center;
	top: 40%;
	left: 18%;
	transition: .5s ease;
}
.total:hover {
	font-size: 14pt;
	transition: .5s ease;
}
</style>